import {SerializedError} from "@reduxjs/toolkit";
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {getAppErrors} from "@pg-mono/request/src/error/response_error";
import {IAppError} from "@pg-mono/request-state";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {createApplicationApi} from "../../lead/api/create_application";
import {IAppDispatch} from "../../store/store";
import {fetchCookies} from "../../user/api/fetch_cookies";
import {IApplication} from "../types/IApplication";
import {IApplicationOptions} from "../types/IApplicationOptions";

interface IApplicationPostResponseData {
    data: IApplication;
    error?: undefined;
}

interface IApplicationPostResponseError {
    data?: undefined;
    error: FetchBaseQueryError | SerializedError;
}

export const handlePostApplicationResponse = async (
    response: IApplicationPostResponseData | IApplicationPostResponseError,
    triesLeft = 1,
    dispatch: IAppDispatch,
    leadPayload: Partial<IApplication>,
    postOptions?: IApplicationOptions
): Promise<IApplication | void> => {
    //400
    if (response.error && "status" in response.error && response.error.status === 400) {
        const appError = getAppErrors(response.error.status, response.error.data as Record<string, string[]>);
        const applicationBlockedError = appError.fieldErrors[0] as unknown as {
            error: string;
        };
        if (
            applicationBlockedError &&
            applicationBlockedError.error.match(/Zgłoszenie nie może być wysłane na [\wśćę]+ archiwalną/gm) &&
            postOptions?.on400ApplicationBlockedError
        ) {
            // BE blocks application post when lead is sent to an archived offer (ie. view was cached by FE etc.)
            // casting error because this one is kinda special :pikachu:
            postOptions.on400ApplicationBlockedError(appError);
            // do not rethrow, we don't want
            return;
        }
        postOptions?.on400Response && postOptions.on400Response(appError);

        // rethrow error to be handled in form
        throw {appError: {fieldErrors: appError.fieldErrors, status: appError.status, nonFieldErrors: appError.nonFieldErrors}} as unknown as IAppError;
    }

    //403
    if (response.error && "status" in response.error && response.error.status === 403) {
        notifyBugsnag(response.error, `applicationPost: catch 403 (triesLeft: ${triesLeft})`, {originalError: JSON.stringify(response.error)});
        if (!triesLeft) {
            // die silently [']
            // at this point I'm not sure if void is a business requirement, but this can happen if user has too many session/csrftoken/auth issues
            return;
        }

        await fetchCookies();
        // POST create after fetching cookies with new csrftoken
        const applicationResponse = await dispatch(createApplicationApi.endpoints.createApplication.initiate(leadPayload));
        return handlePostApplicationResponse(applicationResponse, --triesLeft, dispatch, leadPayload, postOptions);
    }
    if (response.data) {
        return response.data;
    }
    return;
};
import {SerializedError} from "@reduxjs/toolkit";
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {getAppErrors} from "@pg-mono/request/src/error/response_error";
import {IAppError} from "@pg-mono/request-state";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {createApplicationApi} from "../../lead/api/create_application";
import {IAppDispatch} from "../../store/store";
import {fetchCookies} from "../../user/api/fetch_cookies";
import {IApplication} from "../types/IApplication";
import {IApplicationOptions} from "../types/IApplicationOptions";

interface IApplicationPostResponseData {
    data: IApplication;
    error?: undefined;
}

interface IApplicationPostResponseError {
    data?: undefined;
    error: FetchBaseQueryError | SerializedError;
}

export const handlePostApplicationResponse = async (
    response: IApplicationPostResponseData | IApplicationPostResponseError,
    triesLeft = 1,
    dispatch: IAppDispatch,
    leadPayload: Partial<IApplication>,
    postOptions?: IApplicationOptions
): Promise<IApplication | void> => {
    //400
    if (response.error && "status" in response.error && response.error.status === 400) {
        const appError = getAppErrors(response.error.status, response.error.data as Record<string, string[]>);
        const applicationBlockedError = appError.fieldErrors[0] as unknown as {
            error: string;
        };
        if (
            applicationBlockedError &&
            applicationBlockedError.error.match(/Zgłoszenie nie może być wysłane na [\wśćę]+ archiwalną/gm) &&
            postOptions?.on400ApplicationBlockedError
        ) {
            // BE blocks application post when lead is sent to an archived offer (ie. view was cached by FE etc.)
            // casting error because this one is kinda special :pikachu:
            postOptions.on400ApplicationBlockedError(appError);
            // do not rethrow, we don't want
            return;
        }
        postOptions?.on400Response && postOptions.on400Response(appError);

        // rethrow error to be handled in form
        throw {appError: {fieldErrors: appError.fieldErrors, status: appError.status, nonFieldErrors: appError.nonFieldErrors}} as unknown as IAppError;
    }

    //403
    if (response.error && "status" in response.error && response.error.status === 403) {
        notifyBugsnag(response.error, `applicationPost: catch 403 (triesLeft: ${triesLeft})`, {originalError: JSON.stringify(response.error)});
        if (!triesLeft) {
            // die silently [']
            // at this point I'm not sure if void is a business requirement, but this can happen if user has too many session/csrftoken/auth issues
            return;
        }

        await fetchCookies();
        // POST create after fetching cookies with new csrftoken
        const applicationResponse = await dispatch(createApplicationApi.endpoints.createApplication.initiate(leadPayload));
        return handlePostApplicationResponse(applicationResponse, --triesLeft, dispatch, leadPayload, postOptions);
    }
    if (response.data) {
        return response.data;
    }
    return;
};
